import { useState, useCallback, useRef } from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { Row, Col, Button } from 'antd';
import styled from '@emotion/styled';
import { JustRightHeightModal } from 'components/styled/scoped';
import { css } from '@emotion/css';
import ResultSelect from './ResultSelect';
import type { Value } from './ResultSelect';
import { useTranslate } from '@tolgee/react';
import { useLabel } from '@knowledge/common/hooks/useGroup';

function useResult(type: Knowledge.KnowledgeType, loading: boolean) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslate();
  const [checkResult, setCheckResult] = useState<Knowledge.KnowledgeItem[]>([]);
  const [contentValue, setContentValue] = useState({});
  const mutateFnRef = useRef();
  const open = useCallback((data, contentValue, mutateFn) => {
    setCheckResult(data);
    setContentValue(contentValue);
    mutateFnRef.current = mutateFn;
    setVisible(true);
  }, []);
  const close = useCallback(() => setVisible(false), []);
  const [selectedValue, setSelectValue] = useState<Value[]>([]);
  const { knowledgeLabel } = useLabel();
  const keepRef = useRef<Value[]>([]);

  const submit = () => {
    mutateFnRef.current?.({
      keep: keepRef.current?.map((each) => {
        const { uuid, checked, selected, ...rest } = each;
        return {
          ...rest,
        };
      }),
      overwrite: selectedValue?.map((each) => {
        const { uuid, checked, selected, ...rest } = each;
        return {
          ...rest,
        };
      }),
    });
  };

  const modalInstance = visible && (
    <JustRightHeightModal
      title={t('aide.提示')}
      width={990}
      visible={visible}
      onCancel={close}
      centered
      className={css`
        .ant-modal-body {
          margin: 0 !important;
          padding: 0;
        }
      `}
      footer={
        <Row align="middle" gutter={12} justify="end">
          <Col>
            {t('aide.已选x项', {
              x: selectedValue?.length,
            })}
          </Col>
          <Col>
            <Button onClick={close}>{t('translation.取消')}</Button>
          </Col>
          <Col>
            <Button loading={loading} type="primary" onClick={submit}>
              {t('translation.确定')}
            </Button>
          </Col>
        </Row>
      }
    >
      <Container>
        <div className="h-full flex flex-col basis-[100%]">
          <Tip>
            <InfoCircleFilled style={{ color: '#f2a200' }} />
            <span>{t('knowledge.modifyConditionTip', { x: knowledgeLabel[type] })}</span>
          </Tip>
          <ResultSelect
            value={checkResult}
            contentValue={contentValue}
            type={type}
            onChange={(value) => {
              const { keep, overwrite } = value;
              setSelectValue(overwrite);
              keepRef.current = keep;
            }}
          />
        </div>
      </Container>
    </JustRightHeightModal>
  );
  return [open, close, modalInstance] as const;
}

const Container = styled.div`
  max-height: 600px;
  height: calc(94vh - 108px);
  display: flex;
  align-items: stretch;
`;

const Tip = styled.div`
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: var(--fett-surface-warning-bg);
  font-size: 14px;
  & > span {
    &:last-child {
      margin-left: 8px;
    }
  }
`;

export default useResult;
